import React, { useState } from "react";
import { Form, Select } from "antd";
import "./override.css";
import styles from "./antdDropdown.module.css";
import { AiOutlineCaretDown } from "react-icons/ai";

const AntdDropdown = ({ options, name, label, onChange, style,className,placeholder,ref,selectedValue }) => {
  const [active, setActive] = useState();
  const handleChange = (value) => {
    setActive(value);
  };
  // console.log(form.getFieldValue('role'));
  return (
    <Form.Item
      style={{ ...style, backgroundColor: "transparent" }}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      label={label ? <label className={styles.label_style}>{label}</label> : null}
      name={name}
      //  rules={rules}
    >
      <div className={className ? className : "select_custom_style"}>
        <Select
        ref={ref}
          style={{ backgroundColor: "transparent" }}
          className={styles.select}
          dropdownStyle={{ backgroundColor: "transparent" }}
          placeholder={placeholder}
          suffixIcon={<AiOutlineCaretDown size={25} color="#f6921e" />}
          onChange={(value) => {
            onChange(value);
            handleChange(value);
          }}
          value={selectedValue}
        >
          {options?.map((data, i) => (
            <Select.Option
              className={styles.option}
              key={i}
              style={{
                backgroundColor:
                  active == data.value
                    ? "var(--secondary-color)"
                    : "var(--primary-color)",
                color: "white",
                fontSize: "var(--paragraph-font-size)",
                marginLeft: "0%",
                borderRadius: "0px",
              }}
              value={data.value}
            >
              {data.option}
            </Select.Option>
          ))}
        </Select>
      </div>
    </Form.Item>
  );
};

export default AntdDropdown;
